import { HStack, Text, VStack } from "@chakra-ui/react";
import { UserFragment } from "gql/graphql";
import { InfoIcon } from "modules/icons";
import React, { memo } from "react";
import colors from "app/colors";
import UserInvite from "./user-invite";
import { isUserInactive } from "modules/utils/Functions";

interface IProps {
  user: UserFragment;
}

const UserInactive: React.FC<IProps> = ({ user }) => {
  if (!isUserInactive(user)) {
    return null;
  }

  return (
    <HStack p={2} alignItems="start" bg={colors.blueLight} borderRadius="4px">
      <InfoIcon boxSize={5} fill={colors.blue} />
      <VStack alignItems="start" gap={0}>
        <Text fontWeight={400} fontSize={14}>
          This user is inactive on Synco. In order for them to receive messages
          they should login or subscribe to SMS messaging.
        </Text>
        <UserInvite user={user} />
      </VStack>
    </HStack>
  );
};

export default memo(UserInactive);
